export const copyToClipboard = () => {
    document.querySelectorAll("pre").forEach(function(codeBlock) {
        var button = document.createElement("button");
        button.className = "button button-copy-code";
        button.type = "button";
        button.innerText = "Copy";

        button.addEventListener("mouseenter", function() {
            button.classList.add("active");
        });

        button.addEventListener("mouseleave", function() {
            button.classList.remove("active");
        });

        button.addEventListener("click", function() {
            let toCopy = codeBlock.innerText;
            toCopy = toCopy.charAt(0) === "$" ? toCopy.slice(1) : toCopy;

            navigator.clipboard.writeText(toCopy).then(
                function() {
                    button.blur();

                    button.classList.add("copied");
                    button.innerText = "Copied!";

                    setTimeout(function() {
                        button.innerText = "Copy";
                        button.classList.remove("copied");
                    }, 2000);

                    // Curity.toast('Copied to clipboard!', 'success');
                },
                function(error) {
                    button.innerText = "Error";
                }
            );
        });

        var pre = codeBlock.parentNode;

        pre.appendChild(button);

        pre.addEventListener("mouseenter", function(event) {
            button.classList.add("active");
        });

        pre.addEventListener("mouseleave", function(event) {
            button.classList.remove("active");
        });
    });
};
